// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.not-found {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 20px;
}
.not-found .not-found-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
  text-align: center;
}
.not-found .not-found-header .not-found-icon-wrapper {
  width: 90px;
  height: 90px;
  background-color: #F3F4F6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}
.not-found .not-found-header .not-found-icon-wrapper .not-found-icon {
  font-size: 40px;
  color: #6B7280;
}
.not-found .not-found-header .not-found-title {
  font-size: 18px;
  font-weight: 510;
  color: #6B7280;
  margin: 0 0 8px 0;
}
.not-found .not-found-header .not-found-subtitle {
  font-size: 13px;
  font-weight: 400;
  color: #595959;
  margin: 0;
  max-width: 340px;
  line-height: 1.4;
}
.not-found .not-found-details-section {
  width: 100%;
  background-color: #FFFFFF;
  border: 1px solid #F0F0F0;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
}
.not-found .not-found-details-section .not-found-status-badge {
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 16px;
  display: inline-block;
  background-color: #F3F4F6;
  color: #6B7280;
  border: 1px solid #6B7280;
}
.not-found .not-found-details-section .what-to-do-next {
  width: 100%;
  margin-top: 0;
}
.not-found .not-found-details-section .what-to-do-next .what-to-do-title {
  font-size: 14px;
  font-weight: 500;
  color: #8E7E54;
  margin: 0 0 12px 0;
}
.not-found .not-found-details-section .what-to-do-next .what-to-do-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.not-found .not-found-details-section .what-to-do-next .what-to-do-list li {
  font-size: 13px;
  font-weight: 400;
  color: #595959;
  line-height: 1.6;
  margin-bottom: 6px;
}
.not-found .not-found-details-section .what-to-do-next .what-to-do-list li:last-child {
  margin-bottom: 0;
}
.not-found .go-home-button-section {
  width: 100%;
  margin-top: auto;
  padding-top: 20px;
}
.not-found .go-home-button-section .go-home-button {
  height: 48px;
  font-size: 15px;
  font-weight: 500;
  border-radius: 8px;
  background-color: #8E7E54;
  border-color: #8E7E54;
}
.not-found .go-home-button-section .go-home-button:hover {
  background-color: #8F7A4A;
  border-color: #8F7A4A;
}
/*# sourceMappingURL=NotFound.css.map */`, "",{"version":3,"sources":["webpack://./NotFound.less","webpack://./src/containers/NotFoundPage/components/NotFound.less"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;ACCD;ADLA;EAOE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;ACCF;ADZA;EAcG,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;ACCH;ADtBA;EAwBI,eAAA;EACA,cAAA;ACCJ;AD1BA;EA8BG,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;ACDH;ADhCA;EAqCG,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;ACFH;ADxCA;EA+CE,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;ACJF;ADhDA;EAuDG,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,yBAAA;ACJH;AD3DA;EAmEG,WAAA;EACA,aAAA;ACLH;AD/DA;EAuEI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;ACLJ;ADrEA;EA8EI,gBAAA;EACA,UAAA;EACA,SAAA;ACNJ;AD1EA;EAmFK,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;ACNL;ADQK;EACC,gBAAA;ACNN;ADpFA;EAkGE,WAAA;EACA,gBAAA;EACA,iBAAA;ACXF;ADzFA;EAuGG,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;ACXH;ADaG;EACC,yBAAA;EACA,qBAAA;ACXJ;AACA,uCAAuC","sourcesContent":[".not-found {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding-top: 20px;\n\n\t.not-found-header {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tmargin-bottom: 32px;\n\t\ttext-align: center;\n\n\t\t.not-found-icon-wrapper {\n\t\t\twidth: 90px;\n\t\t\theight: 90px;\n\t\t\tbackground-color: #F3F4F6;\n\t\t\tborder-radius: 50%;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tmargin-bottom: 16px;\n\n\t\t\t.not-found-icon {\n\t\t\t\tfont-size: 40px;\n\t\t\t\tcolor: #6B7280;\n\t\t\t}\n\t\t}\n\n\t\t.not-found-title {\n\t\t\tfont-size: 18px;\n\t\t\tfont-weight: 510;\n\t\t\tcolor: #6B7280;\n\t\t\tmargin: 0 0 8px 0;\n\t\t}\n\n\t\t.not-found-subtitle {\n\t\t\tfont-size: 13px;\n\t\t\tfont-weight: 400;\n\t\t\tcolor: #595959;\n\t\t\tmargin: 0;\n\t\t\tmax-width: 340px;\n\t\t\tline-height: 1.4;\n\t\t}\n\t}\n\n\t.not-found-details-section {\n\t\twidth: 100%;\n\t\tbackground-color: #FFFFFF;\n\t\tborder: 1px solid #F0F0F0;\n\t\tborder-radius: 12px;\n\t\tpadding: 20px;\n\t\tmargin-bottom: 24px;\n\n\t\t.not-found-status-badge {\n\t\t\tpadding: 4px 12px;\n\t\t\tborder-radius: 4px;\n\t\t\tfont-size: 12px;\n\t\t\tfont-weight: 400;\n\t\t\tmargin-bottom: 16px;\n\t\t\tdisplay: inline-block;\n\t\t\tbackground-color: #F3F4F6;\n\t\t\tcolor: #6B7280;\n\t\t\tborder: 1px solid #6B7280;\n\t\t}\n\n\t\t.what-to-do-next {\n\t\t\twidth: 100%;\n\t\t\tmargin-top: 0;\n\n\t\t\t.what-to-do-title {\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tcolor: #8E7E54;\n\t\t\t\tmargin: 0 0 12px 0;\n\t\t\t}\n\n\t\t\t.what-to-do-list {\n\t\t\t\tlist-style: none;\n\t\t\t\tpadding: 0;\n\t\t\t\tmargin: 0;\n\n\t\t\t\tli {\n\t\t\t\t\tfont-size: 13px;\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tcolor: #595959;\n\t\t\t\t\tline-height: 1.6;\n\t\t\t\t\tmargin-bottom: 6px;\n\n\t\t\t\t\t&:last-child {\n\t\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.go-home-button-section {\n\t\twidth: 100%;\n\t\tmargin-top: auto;\n\t\tpadding-top: 20px;\n\n\t\t.go-home-button {\n\t\t\theight: 48px;\n\t\t\tfont-size: 15px;\n\t\t\tfont-weight: 500;\n\t\t\tborder-radius: 8px;\n\t\t\tbackground-color: #8E7E54;\n\t\t\tborder-color: #8E7E54;\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: #8F7A4A;\n\t\t\t\tborder-color: #8F7A4A;\n\t\t\t}\n\t\t}\n\t}\n}\n",".not-found {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding-top: 20px;\n}\n.not-found .not-found-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 32px;\n  text-align: center;\n}\n.not-found .not-found-header .not-found-icon-wrapper {\n  width: 90px;\n  height: 90px;\n  background-color: #F3F4F6;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n.not-found .not-found-header .not-found-icon-wrapper .not-found-icon {\n  font-size: 40px;\n  color: #6B7280;\n}\n.not-found .not-found-header .not-found-title {\n  font-size: 18px;\n  font-weight: 510;\n  color: #6B7280;\n  margin: 0 0 8px 0;\n}\n.not-found .not-found-header .not-found-subtitle {\n  font-size: 13px;\n  font-weight: 400;\n  color: #595959;\n  margin: 0;\n  max-width: 340px;\n  line-height: 1.4;\n}\n.not-found .not-found-details-section {\n  width: 100%;\n  background-color: #FFFFFF;\n  border: 1px solid #F0F0F0;\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 24px;\n}\n.not-found .not-found-details-section .not-found-status-badge {\n  padding: 4px 12px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 400;\n  margin-bottom: 16px;\n  display: inline-block;\n  background-color: #F3F4F6;\n  color: #6B7280;\n  border: 1px solid #6B7280;\n}\n.not-found .not-found-details-section .what-to-do-next {\n  width: 100%;\n  margin-top: 0;\n}\n.not-found .not-found-details-section .what-to-do-next .what-to-do-title {\n  font-size: 14px;\n  font-weight: 500;\n  color: #8E7E54;\n  margin: 0 0 12px 0;\n}\n.not-found .not-found-details-section .what-to-do-next .what-to-do-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.not-found .not-found-details-section .what-to-do-next .what-to-do-list li {\n  font-size: 13px;\n  font-weight: 400;\n  color: #595959;\n  line-height: 1.6;\n  margin-bottom: 6px;\n}\n.not-found .not-found-details-section .what-to-do-next .what-to-do-list li:last-child {\n  margin-bottom: 0;\n}\n.not-found .go-home-button-section {\n  width: 100%;\n  margin-top: auto;\n  padding-top: 20px;\n}\n.not-found .go-home-button-section .go-home-button {\n  height: 48px;\n  font-size: 15px;\n  font-weight: 500;\n  border-radius: 8px;\n  background-color: #8E7E54;\n  border-color: #8E7E54;\n}\n.not-found .go-home-button-section .go-home-button:hover {\n  background-color: #8F7A4A;\n  border-color: #8F7A4A;\n}\n/*# sourceMappingURL=NotFound.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
